module.exports = __webpack_public_path__ + "img/holiday-on-ice-75-ans.b88b4acb.jpg";